import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, App, AlertController } from 'ionic-angular';
import { DataProvider } from "../../providers/data/data";
import { EntryPage } from "../entry/entry";
import { DateTime } from 'ionic-angular/components/datetime/datetime';
import { ReturnStatement } from '@angular/compiler/src/output/output_ast';
import { HomePage } from '../home/home';

@IonicPage()
@Component({
  selector: 'page-detail',
  templateUrl: 'detail.html',
})
export class DetailPage {

  item: { Id: string, Actual: number, Description: string, Goal: number, Icon: string, Month: string, Name: string, Status: string, Year: number, Details: { Id: string, Location: string, When: string, Amount: number, Taxable: boolean, Description: string }[] }

  details: {
    Id: string;
    Location: string;
    When: string;
    Amount: number;
    Taxable: boolean;
    Description: string;
  }[]

  year: number;
  month: string;
  name: string;
  total: number;
  icon: string;

  private monthYear: Date;

  constructor(public navCtrl: NavController, public navParams: NavParams, public app: App, public dataProvider: DataProvider, public alerCtrl: AlertController) {
    this.item = navParams.get("item");
    this.details = this.item.Details;

    this.year = this.item.Year;
    this.month = this.item.Month;
    this.name = this.item.Name;
    this.total = this.item.Actual;
    this.icon = this.item.Icon;
    this.monthYear = this.dataProvider.whenPost;
  }

  ionViewDidLoad() {

  }

  doAdd() {
    this.navCtrl.push(EntryPage, { item: this.item });
  };

  doDelete(e) {
    let confirm = this.alerCtrl.create({
      title: "Delete this Entry?",
      message: "You are about to permanently remove this entry from " + e.Location + " in the amount of $" + e.Amount + ". Once it is gone, it is gone!",
      buttons: [
        {
          text: "Cancel",
          handler: () => {
            console.log("Cancelled clicked");
          }
        },
        {
          text: "Delete",
          handler: () => {
            let res = this.dataProvider.entryDelete(e.Id);
            if (res) {
              this.navCtrl.push(HomePage);
            }
          }
        }
      ]
    });
    confirm.present()
  };

  doEdit(e) {
    console.dir(e);
  };
}


// WEBPACK FOOTER //
// ./src/pages/detail/detail.ts